import { AreaInterestAPI } from "../api";
export class AreaInterest {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }

  static async createAreaInterest(payload) {
    const { data } = await AreaInterestAPI.createAreaInterest(payload);
    return new AreaInterest(data.result)
  }
}